import { Box, Button, IconButton, Typography } from "@mui/material";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { helpContentState, helpFixState, openHelpState } from "../recoil";
import { OpenInNewIcon, OpenInBrowserIcon, CloseIcon } from "../icons";
import { t } from "i18next";
import { useState } from "react";
import HelpWindow from "./HelpWindow";

export default function HelpFixComponent() {
  const setHelpFix = useSetRecoilState(helpFixState);
  const [openHelp, setOpenHelp] = useRecoilState(openHelpState);
  const helpContent = useRecoilValue(helpContentState);
  const [showHelpWindow, setShowHelpWindow] = useState(false);

  const handleOpenHelpWindow = () => {
    setShowHelpWindow(true);
  };

  const handleOpenModal = () => {
    setOpenHelp(true);
    setHelpFix(false);
  };

  const handleCloseHelpWindow = () => {
    setShowHelpWindow(false);
  };

  return (
    <>
      <Box
        id="help-box"
        sx={{
          width: "500px",
          flexDirection: "column",
          height: "100vh",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            borderBottom: 1,
            borderColor: "divider",
            flexShrink: 0,
          }}
        >
          <Typography variant="h5" sx={{ color: "var(--text-color)" }}>
            {t("Help")}
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton
              onClick={handleOpenHelpWindow}
              size="small"
              title={t("Open in new window")}
            >
              <OpenInNewIcon />
            </IconButton>
            <IconButton
              onClick={handleOpenModal}
              size="small"
              title={t("Open in modal")}
            >
              <OpenInBrowserIcon />
            </IconButton>
            <Button onClick={() => setHelpFix(false)} startIcon={<CloseIcon />}>
              {t("Close")}
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            p: 2,
            overflow: "auto",
            flex: 1,
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <Typography variant="body1" sx={{ color: "var(--text-color)" }}>
            {helpContent}
          </Typography>
        </Box>
      </Box>
      <HelpWindow isOpen={showHelpWindow} onClose={handleCloseHelpWindow} />
    </>
  );
}
